import { gql, type TypedDocumentNode } from '@apollo/client';

export const UNAVAILABILITY_QUERY: TypedDocumentNode<UnavailabilityQueryData, UnavailabilityQueryVars> = gql`
    query UNAVAILABILITY_QUERY($providerId: Long!) {
        schedule(providerId: $providerId) {
            unavailabilities {
                startDate
                endDate
                oneTime
                scheduleId
                unavailabilityReasonID
                shifts {
                    startDay
                    endDay
                }
                seriesId
            }
            unavailabilityReasons {
                description
                editable
                id
            }  
        }
    }
`

export interface UnavailabilityReason {
    description: string,
    editable: boolean,
    id: number
}

export interface UnavailabilityQueryVars {
    providerId: number
}

export interface UnavailabilityQueryData {
    schedule: {
        unavailabilities: UnavailabilityData[],
        unavailabilityReasons: UnavailabilityReason[],
        __typename?: string
    }
}

export interface UnavailabilityData {
    startDate: Date,
    endDate: Date,
    oneTime: Boolean,
    unavailabilityReasonID: number,
    unavailabilityReason?: {
        description: string,
        editable: boolean,
        id: number
    },
    shifts: {
        startDay: number,
        endDay: number
    }[],
    scheduleId: number,
    seriesId: string
}

export const SAVE_UNAVAILABILITY_MUTATION = gql`
    mutation SAVE_UNAVAILABILITY_MUTATION($activityId: Int, $applyToSeries: Boolean, $daysOfTheWeek: [Int!], $endDate: DateTime!, $monthly: Boolean, $providerId: Int!, $reasonId: Short!, $scheduleId: Int, $seriesId: Uuid, $startDate: DateTime!, $username: String, $wspTaskCode: String) {
        saveUnavailability(activityId: $activityId, applyToSeries: $applyToSeries, daysOfTheWeek: $daysOfTheWeek, endDate: $endDate, monthly: $monthly, providerId: $providerId, reasonId: $reasonId, scheduleId: $scheduleId, seriesId: $seriesId, startDate: $startDate, username: $username, wspTaskCode: $wspTaskCode)
    }
`

export interface SaveUnavailabilityMutationVars {
    activityId?: number,
    applyToSeries?: boolean,
    daysOfTheWeek?: number[],
    endDate: Date,
    monthly?: boolean,
    providerId: number,
    reasonId: number,
    scheduleId?: number,
    seriesId?: string,
    startDate: Date,
    username?: string,
    wspTaskCode?: string
}

export const DELETE_UNAVAILABILITY_MUTATION = gql`
    mutation DELETE_UNAVAILABILITY_MUTATION($eventDate: DateTime, $providerId: Int!, $scheduleId: Int!, $username: String, $seriesId: Uuid) {
        deleteUnavailability(eventDate: $eventDate, providerId: $providerId, scheduleId: $scheduleId, username: $username, seriesId: $seriesId)
    }
`

export interface DeleteUnavailabilityMutationVars {
    eventDate: Date,
    providerId: number,
    scheduleId: number,
    username: string,
    seriesId?: string
}